var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('talk-modal'),_c('picture-view',{attrs:{"value":_vm.previewImageStatus,"src":_vm.previewImageUrl},on:{"input":_vm.dealImageChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }